module.exports = __webpack_public_path__ + "img/folder.5ba57789.png";